import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectorRef,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { FilterByPipe, OrderByPipe } from 'ngx-pipes';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject, of, concat, Subscription } from 'rxjs';
import {
  distinctUntilChanged,
  switchMap,
  catchError,
  tap,
  map,
} from 'rxjs/operators';

import { AuthService } from '@app/core/auth';
import { ClientService } from '@app/core/client/services/client.service';
import { PipelineService } from '@app/core/pipelines/services/pipeline.service';
import { CategoryService } from '@app/core/products/services/category.service';
import { RfqService, RFQ } from '@app/core/quotes';
import { SettingsService } from '@app/core/settings/services/settings.service';
import { StaffService } from '@app/core/staff';
import { UIStateService } from '@app/shared/services/ui-state.service';

import { NpRfqPipelinePopupComponent } from '../np-rfq-pipeline-popup/np-rfq-pipeline-popup.component';
import { NpTagsPopupComponent } from '../np-tags-popup/np-tags-popup.component';

@Component({
  selector: 'cnc-np-pipeline-view',
  templateUrl: './np-pipeline-view.component.html',
  styleUrls: ['./np-pipeline-view.component.scss'],
  providers: [FilterByPipe, DatePipe, OrderByPipe],
})
export class NpPipelineViewComponent implements OnInit, OnDestroy {
  initialize :boolean = false;
  pipelineStatus :any[] = [];
  records :any = {};

  searchKey :string = '';

  filter :any = { rfq_state: '0' };
  checked :any = [];
  showFilter :boolean = false;
  checkedAll :boolean = false;
  loadingPipelines :boolean = false;

  pipelines :any[] = [];
  activePipeline :any;

  subscription :Subscription;

  goTeam :any[] = [];
  goStaff :any[] = [];

  addingRfq :boolean;
  rfq$ :Observable<any[]>;
  rfqLoading = false;
  rfqInput$ = new Subject<string>();
  rfqProduct :any;

  subscriptions :Subscription[] = [];

  constructor(
    public authService :AuthService,
    public settingsSvc :SettingsService,
    public rfqSvc :RfqService,
    private router :Router,
    private ref :ChangeDetectorRef,
    private modal :NgbModal,
    private translate :TranslateService,
    public pcatService :CategoryService,
    public staffService :StaffService,
    public clientSvc :ClientService,
    private uiStateSvc :UIStateService,
    private toastr :ToastrService,
    public pipelineSvc :PipelineService,

    private filterBy :FilterByPipe,
    private datePipe :DatePipe,
    private orderBy :OrderByPipe,
  ) {}

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
  }

  ngOnInit() {
    this.initialize = true;
    const stateView = this.uiStateSvc.getState('quotes-pipelines');
    if (stateView) {
      this.filter = stateView;
    }
    this.initialize = false;

    // get pipelines
    this.loadingPipelines = true;
    this.subscription = this.pipelineSvc.pipelines$.subscribe((pipelines) => {
      if (pipelines && pipelines.data) {
        this.pipelines = pipelines.data.filter((row) => row.pipeline_type == 1);
        if (!this.filter.pipelineId) {
          this.filter.pipelineId = this.pipelines[0].id;
        }
        this.setPipeline();
        // this.ref.detectChanges()
      }
      setTimeout(() => {
        this.loadingPipelines = false;
      }, 10);
    });

    this.loadRfqs();
  }

  setTags(rfq :any, idx) {
    const modalRef = this.modal.open(NpTagsPopupComponent, {});
    modalRef.componentInstance.rfq = rfq;
  }

  moveToOtherPipeline(rfq :any, idx) {
    const modalRef = this.modal.open(NpRfqPipelinePopupComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.rfq = rfq;
    modalRef.componentInstance.moveRfqToPipeline = 1;
    modalRef.result.then(
      (pipelines :any) => {
        rfq.pipelines = pipelines;
        if (pipelines && pipelines.length > 0) {
          const pipeline = pipelines.find(
            (row) => row.pipeline_id == this.activePipeline.id,
          );
          if (pipeline) {
            const stageIdx = this.activePipeline.stages.findIndex(
              (row) => row.id == pipeline.pipeline_stage_id,
            );
            rfq.priority = pipeline.priority;
            if (idx != stageIdx) {
              // add to new stage
              this.activePipeline.stages[stageIdx].recordsRaw.splice(0, 0, rfq);
              // this.activePipeline.stages[stageIdx].recordsRaw = this.orderBy.transform(this.activePipeline.stages[stageIdx].recordsRaw, ['-priority']);;
              // remove from existing stage
              const rfqIdx = this.activePipeline.stages[idx].recordsRaw.findIndex(
                (row) => row.id == rfq.id,
              );
              this.activePipeline.stages[idx].recordsRaw.splice(rfqIdx, 1);
              this.filterStage(this.activePipeline.stages[stageIdx]);
              this.filterStage(this.activePipeline.stages[idx]);
            } else {
              // rfq.priority = pipeline.priority;
              const rfqIdx = this.activePipeline.stages[idx].recordsRaw.findIndex(
                (row) => row.id == rfq.id,
              );
              this.activePipeline.stages[idx].recordsRaw.splice(rfqIdx, 1, rfq);
              // this.activePipeline.stages[idx].recordsRaw = this.orderBy.transform(this.activePipeline.stages[idx].recordsRaw, ['-priority']);;
              this.filterStage(this.activePipeline.stages[idx]);
            }
            this.ref.detectChanges();
          } else {
            const rfqIdx = this.activePipeline.stages[idx].recordsRaw.findIndex(
              (row) => row.id == rfq.id,
            );
            this.activePipeline.stages[idx].recordsRaw.splice(rfqIdx, 1);
            this.filterStage(this.activePipeline.stages[idx]);
            this.ref.detectChanges();
          }
        }
      },
      (_) => {},
    );
  }

  addToPipeline() {
    if (this.rfqProduct && this.rfqProduct.id && !this.addingRfq) {
      this.addingRfq = true;
      const payload :any = {
        rfq_id: this.rfqProduct.id,
        pipeline_stage_id: this.activePipeline.stages[0].id,
      };
      this.pipelineSvc
        .addRfqToPipeline(this.activePipeline.id, payload)
        .subscribe((resp :any) => {
          if (resp && resp.id) {
            const rfq = Object.assign({}, this.rfqProduct);
            this.activePipeline.stages[0].recordsRaw.splice(0, 0, rfq);
            // this.activePipeline.stages[0].records.splice(0,0,resp);
            this.addingRfq = false;
            this.rfqProduct = null;
            this.ref.detectChanges();
          }
        });
    }
  }

  setPipeline() {
    if (!this.filter.pipelineId) {
      return;
    }
    this.activePipeline = this.pipelines.find(
      (row) => row.id == this.filter.pipelineId,
    );
    if (!this.activePipeline && this.pipelines.length > 0) {
      this.activePipeline = this.pipelines[0];
    }
    if (!this.activePipeline) {
      return;
    }

    this.activePipeline.stages = this.orderBy.transform(
      this.activePipeline.stages,
      ['order'],
    );

    this.activePipeline.stages.forEach((stage) => {
      stage.loading = true;
      const params = {
        all: 1,
        pipeline_id: this.activePipeline.id,
        pipeline_stage_id: stage.id,
      };
      this.subscriptions.push(
        this.rfqSvc.getAsync(params).subscribe((rfqs) => {
          stage.recordsRaw = rfqs;
          stage.records = rfqs;
          stage.count = stage.records.length;
          this.filterStage(stage);
          stage.loading = false;
          stage.tags = [];
          if (stage.tag_ids) {
            stage.tags = this.activePipeline.tags.filter(
              (row) => stage.tag_ids.indexOf(row.id) >= 0,
            );
          }
          this.ref.detectChanges();
        }),
      );
      // this.pipelineSvc.getPipelineRfqs(this.filter.pipelineId, { stage_id: stage.id }).subscribe((rfqs: any) => {
      // })
    });
    this.uiStateSvc.setState('quotes-pipelines', this.filter);
    // this.getRecords();
  }

  toggleTag(tagId, activePipeline) {
    if (!activePipeline.tag_ids) {
      activePipeline.tag_ids = [tagId];
    } else {
      const idx = activePipeline.tag_ids.indexOf(tagId);
      if (idx >= 0) {
        activePipeline.tag_ids.splice(idx, 1);
      } else {
        activePipeline.tag_ids.push(tagId);
      }
    }
    this.rfqSvc
      .updateRfqPipelineStage(activePipeline.rfq_id, this.activePipeline.id, {
        tag_ids: activePipeline.tag_ids,
      })
      .subscribe();
  }

  getRecords() {
    this.activePipeline.stages.forEach((stage) => {
      this.filterStage(stage);
    });
  }

  isTagActive(tagId, rfqPipelineTagIds) {
    if (!rfqPipelineTagIds || rfqPipelineTagIds.length == 0) {
      return false;
    }

    return rfqPipelineTagIds.indexOf(tagId) >= 0;
  }

  filterStage(stage :any) {
    let records = stage.recordsRaw;
    if (this.filter.product) {
      records = this.filterBy.transform(
        records,
        ['product_name'],
        this.filter.product,
      );
    }
    if (this.filter.sku) {
      records = this.filterBy.transform(records, ['internal_sku'], this.filter.sku);
    }
    if (this.filter.rfq_dept && this.filter.rfq_dept > 0) {
      records = this.filterBy.transform(
        records,
        ['product_dept_id'],
        this.filter.rfq_dept,
      );
    }
    if (this.filter.starred && this.filter.starred >= 0) {
      records = this.filterBy.transform(records, ['starred'], this.filter.starred);
    }
    if (this.filter.date) {
      records = this.filterBy.transform(
        records,
        ['created_at'],
        this.datePipe.transform(this.filter.date, 'yyyy-MM-dd'),
      );
    }
    records.forEach((record) => {
      record.activePipeline = record.pipelines.find(
        (row) => row.pipeline_stage_id == stage.id,
      );
      record.priority = record.activePipeline.priority;
    });
    stage.records = this.orderBy.transform(records, ['-priority']);
  }

  drop(event :CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    } else {
      const rfq :any = event.item.data;
      const payload :any = {
        rfq_id: rfq.id,
        pipeline_id: event.item.data.pipeline_id,
        pipeline_stage_id: this.activePipeline.stages[event.container.id].id,
      };
      this.rfqSvc
        .updateRfqPipelineStage(rfq.id, this.activePipeline.id, payload)
        .subscribe();

      this.activePipeline.stages[event.container.id].count += 1;
      this.activePipeline.stages[event.previousContainer.id].count -= 1;

      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  showDetails(rfq :RFQ, v ?:string) {
    // this.rfqService.setActive(rfq, true);
    if (v) {
      this.router.navigate(['inventory', rfq.id, 'view'], {
        queryParams: { v: v },
      });
    } else {
      this.router.navigate(['inventory', rfq.id, 'view']);
    }
  }

  mySalesClient(userAccount) {
    if (!userAccount.go_team_member) {
      return false;
    }

    return userAccount.go_team_member.find((row) => {
      return row.staff_id == this.authService.loginUser.id;
    })
      ? true
      : false;
  }

  resetFields() {
    delete this.filter.date;
    delete this.filter.sku;
    delete this.filter.product;
    delete this.filter.starred;
    delete this.filter.rfq_dept;

    this.getRecords();
  }

  trackByFn(item :any) {
    return item.id;
  }

  private loadRfqs() {
    this.rfq$ = concat(
      of([]), // default items
      this.rfqInput$.pipe(
        distinctUntilChanged(),
        tap(() => (this.rfqLoading = true)),
        switchMap((term) =>
          this.rfqSvc.getAsync({ sku: term }).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.rfqLoading = false)),
            map((resp) => resp.data),
          ),
        ),
      ),
    );
  }
}
